export const isFilledQueryValue = value =>
  value != null && value !== '' && !(Array.isArray(value) && value.length === 0);

export const compactQuery = query =>
  Object.fromEntries(Object.entries(query || {}).filter(([, value]) => isFilledQueryValue(value)));

const toKeySet = keys => (keys instanceof Set ? keys : new Set(keys || []));

const omitEmptyNestedFilters = value => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return value;
  const cleaned = compactQuery(value);
  return Object.keys(cleaned).length ? cleaned : undefined;
};

export const omitEmptyQueryValues = (query, { preserveKeys } = {}) => {
  const preserved = toKeySet(preserveKeys);

  return Object.fromEntries(
    Object.entries(query || {}).map(([key, value]) => {
      if (key === 'filters') return [key, omitEmptyNestedFilters(value)];
      if (preserved.has(key) && !isFilledQueryValue(value)) return [key, ''];
      return [key, isFilledQueryValue(value) ? value : undefined];
    }),
  );
};

export const wrapFilterSetQuery = (setQuery, options) => {
  if (!setQuery) return setQuery;

  return update => {
    setQuery(prevQuery => {
      const nextQuery =
        typeof update === 'function' ? update(prevQuery) : { ...prevQuery, ...update };
      return omitEmptyQueryValues(nextQuery, options);
    });
  };
};
